import * as React from "react";
import { useTranslation } from "react-i18next";

export const IframeTitle = (): JSX.Element => {
    const { t } = useTranslation();
    return <div className="title-iframe">{t("partselector.iframe-title")}</div>;
};
